import { GQL_MUTATION } from "../utils/APIs"
import { mutation, query } from "gql-query-builder";
import { ref, reactive } from "vue";
import HttpClient from "project-blue-http-client";
import { NOTIFICATIONS } from "./subscription";

export const reqSignal = ref(new AbortController());
export const inProgress = ref(false);

export const ASSET_PROFILE_TYPE = "ASSET_PROFILE";
export const COMPANY_PROFILE_TYPE = "COMPANY";
export const COUNTRY_PROFILE_TYPE = "COUNTRY";
export const SUBSCRIPTION_FILES_PROFILE_TYPE = "SUBSCRIPTION_FILES";
export const PROFILE_TYPES = ["ALL", "ASSET", "COUNTRY", "COMPANY", "FILES"];

export const MARKET_SERVICE_TYPE = "marketService";
export const COST_SERVICE_TYPE = "costService";

export const getNotificationMessage = (nth) => {
    if (nth.type === SUBSCRIPTION_FILES_PROFILE_TYPE) {
        if (nth.serviceType === MARKET_SERVICE_TYPE) return "Market Service file uploaded";
        if (nth.serviceType === COST_SERVICE_TYPE) return "Cost Analysis file uploaded";
        return "Subscription file uploaded";
    }
    return `${nth.type.charAt(0).toUpperCase()}${nth.type.slice(1).toLowerCase().replace("_", " ")} updated`;
}

export const openNotification = async (id) => {
    const gqlQuery = GQL_MUTATION.OPEN_NOTIFICATION;
    inProgress.value = true;

    let client = new HttpClient(gqlQuery.baseUrl);
    await client.get(`${gqlQuery.controller}/${gqlQuery.operation}/${id}`)
        .then(() => inProgress.value = false);
}

export const dismissNotification = (id) => {
    NOTIFICATIONS.value = NOTIFICATIONS.value.filter((n) => n.id !== id);
    openNotification(id);
}
